"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Dollar = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 245 500"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  d: "M143.421 500v-50.263c32.105-3.333 57.061-14.035 74.868-32.105 17.807-18.07 26.711-41.93 26.711-71.58 0-18.596-3.553-34.824-10.658-48.684-7.105-13.86-18.158-26.008-33.158-36.447-15-10.439-35.877-20-62.631-28.684-26.755-8.684-45.965-18.333-57.632-28.948-11.667-10.614-17.5-24.868-17.5-42.763 0-19.298 5.526-34.342 16.579-45.131 11.053-10.79 27.018-16.184 47.895-16.184 20 0 35.877 7.28 47.631 21.842 11.755 14.561 17.632 34.21 17.632 58.947h48.42c0-35.965-8.2-64.298-24.604-85-16.404-20.702-39.342-33.07-68.816-37.105V0h-39.21v57.632c-29.299 3.508-52.325 14.473-69.08 32.894-16.754 18.421-25.131 42.018-25.131 70.79 0 28.245 8.552 51.535 25.658 69.868 17.105 18.334 44.342 33.202 81.71 44.605 26.842 8.948 45.921 18.948 57.237 30 11.316 11.053 16.974 24.65 16.974 40.79 0 19.123-6.58 34.21-19.737 45.263-13.158 11.053-31.228 16.58-54.21 16.58-23.51 0-41.667-6.58-54.474-19.738-12.807-13.158-19.21-31.93-19.21-56.316H0c0 34.737 9.254 62.237 27.763 82.5 18.509 20.264 44.08 31.886 76.71 34.869V500h38.948z"
}));

var _default = Dollar;
exports.default = _default;